import { render, staticRenderFns } from "./PagePlanAlimentaireEdition.vue?vue&type=template&id=1ebd897c&scoped=true&"
import script from "./PagePlanAlimentaireEdition.vue?vue&type=script&lang=js&"
export * from "./PagePlanAlimentaireEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebd897c",
  null
  
)

export default component.exports